import React from "react";
import CircleCheckIcon from "../../../../svg/CircleCheckIcon";
import Modal from "../../Modal";
import { Button, Container, TextModal, WrapperButton } from "./styled";

interface SuccessfullySignedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SuccessfullySignedModal: React.FC<SuccessfullySignedModalProps> = ({
  isOpen,
  onClose,
}) => {
  const urlAssinando = process.env.REACT_APP_ASSINANDO;
  const handleCloseWindow = () => {
    onClose();
    window.location.href = `${urlAssinando}/documento-assinado`;
  };
  return (
    <Modal isOpen={isOpen}>
      <Container>
        <CircleCheckIcon />

        <TextModal>Documento assinado com sucesso!</TextModal>
        <WrapperButton>
          <Button
            backgroundColor="#77EC84"
            hoverBackgroundColor="#72E27F"
            color="#2c2c2c"
            onClick={handleCloseWindow}
          >
            PRÓXIMO
          </Button>
        </WrapperButton>
      </Container>
    </Modal>
  );
};

export default SuccessfullySignedModal;
